export default "<div ui-view='playerContent' flex layout='column'></div>\n"